import { ALL_GRANULARITY } from '../../constants/analytics/granularity';
import type { DrilldownMapperBase } from './DrilldownMapperBase';
import { DrilldownMapperDown } from './DrilldownMapperDown';
import { DrilldownMapperUp } from './DrilldownMapperUp';

type Table = {
  granularity?: string;
  activeMode?: string;
  query: {
    dimensions: string[];
    granularity?: string;
  };
};

type State = {
  isMigratedToDrilldown?: boolean;
};

export class DrilldownMapperService {
  constructor(private isDrilldownEnabled: boolean) {}

  buildDrilldownMapper(
    selectedColumns: any[] = [],
    granularity: string = ALL_GRANULARITY,
    dimensions: string[] = [],
    activeHeader: string = ''
  ): DrilldownMapperBase {
    if (this.isDrilldownEnabled) {
      return new DrilldownMapperUp(selectedColumns, granularity, dimensions, activeHeader);
    }
    return new DrilldownMapperDown(selectedColumns, granularity, dimensions, activeHeader);
  }

  needsMigration(state: State) {
    if (this.isDrilldownEnabled) {
      return !state.isMigratedToDrilldown;
    }
    return !!state.isMigratedToDrilldown;
  }

  setAsMigrated(state: State) {
    state.isMigratedToDrilldown = this.isDrilldownEnabled;
  }

  setActiveMode(table: Table) {
    if (this.isDrilldownEnabled) {
      table.activeMode = 'tree';
    } else {
      delete table.activeMode;
    }
  }
}
